const Tutorial_data = {
  "HTML & CSS": [
    { id: "HTML", name: "HTML", link: "/html" },
    { id: "CSS", name: "CSS", link: "/css" },
    { id: "Bootstrap3", name: "Bootstrap3", link: "/bootstrap3" },
    { id: "Bootstrap4", name: "Bootstrap4", link: "/bootstrap4" },
    { id: "Bootstrap5", name: "Bootstrap5", link: "/bootstrap5" },
    { id: "Sass", name: "Sass", link: "/sass" },
    { id: "Colors", name: "Colors", link: "/colors" },
    { id: "Icons", name: "Icons", link: "/icons" },
    { id: "SVG", name: "SVG", link: "/svg" },
    { id: "Canva", name: "Canva", link: "/canva" },
    { id: "Grabhics", name: "Grabhics", link: "/grabhics" },
  ],
  "JavaScript & Web": [
    { id: "JavaScript", name: "JavaScript", link: "/javascript" },
    { id: "React", name: "React", link: "/react" },
    { id: "Vue", name: "Vue", link: "/vue" },
    { id: "Angular", name: "Angular", link: "/angular" },
    { id: "TypeScript", name: "TypeScript", link: "/typescript" },
    { id: "Nodejs", name: "Node Js", link: "/nodejs" },
    { id: "jQuery", name: "jQuery", link: "/jQuery" },
    { id: "Git", name: "Git", link: "/git" },
    { id: "AppML", name: "AppML", link: "/appML" },
    { id: "Json", name: "Json", link: "/json" },
    { id: "Ajax", name: "Ajax", link: "/ajax" },
  ],
  "Web Building": [
    { id: "CreateAWebsite", name: "Create a Website", link: "/createawebsite" },
    { id: "CreateAServer", name: "Create a Server", link: "/createaserver" },
    { id: "WebDevelopment", name: "Web Development", link: "/webdevelopment" },
    { id: "CodeEditor", name: "Code Editor", link: "/codeeditor" },
    { id: "CyberSecurity", name: "Cyber Security", link: "/cybersecurity" },
  ],
  "Data Analytics": [
    { id: "AITutorial", name: "AI Tutorial", link: "/aitutorial" },
    { id: "GenerativeAI", name: "Generative AI", link: "/generativeAI" },
    { id: "ChatGPT", name: "ChatGPT", link: "/chatgpt" },
    { id: "SciPY", name: "SciPY", link: "/scipy" },
    { id: "Statistics", name: "Statistics", link: "/statistics" },
    { id: "Bard", name: "Bard", link: "/bard" },
    {
      id: "Machinelearning",
      name: "Machine Learning",
      link: "/machinelearning",
    },
    { id: "DSA", name: "DSA", link: "/dsa" },
    { id: "DataScience", name: "Data Science", link: "/datascience" },
    { id: "NumPy", name: "NumPy", link: "/numpy" },
    { id: "Pandas", name: "Pandas", link: "/pandas" },
    { id: "Matplotlib", name: "Matplotlib", link: "/matplotlib" },
  ],
  "Backend & Data": [
    { id: "Python", name: "Python", link: "/python" },
    { id: "Java", name: "Java", link: "/java" },
    { id: "PHP", name: "PHP", link: "/php" },
    { id: "SQL", name: "SQL", link: "/sql" },
    { id: "MySQL", name: "MySQL", link: "/mysql" },
    { id: "MongoDB", name: "MongoDB", link: "/mongodb" },
    { id: "AI", name: "AI", link: "/ai" },
    { id: "Nodejs", name: "NodeJs", link: "/nodejs" },
    { id: "Cprograming", name: "C Programming", link: "/cprograming" },
    { id: "CPlusPlus", name: "C++", link: "/cplusplus" },
    { id: "CSharp", name: "C#", link: "/csharp" },
    { id: "R", name: "R", link: "/r" },
    { id: "Kotlin", name: "Kotlin", link: "/kotlin" },
    { id: "Rust", name: "Rust", link: "/rust" },
    { id: "Django", name: "Django", link: "/django" },
    { id: "TypeScript", name: "TypeScript", link: "/typescript" },
    { id: "ASP", name: "ASP", link: "/asp" },
    { id: "Go", name: "Go", link: "/Go" },
    { id: "Git", name: "Git", link: "/git" },
    { id: "XML", name: "XML", link: "/xml" },
    { id: "Excel", name: "Excel", link: "/excel" },
    { id: "Googlesheets", name: "Google sheets", link: "/googlesheets" },
    {
      id: "Machinelearning",
      name: "Machine Learning",
      link: "/machinelearning",
      badge: "HOT",
    },
    {
      id: "DataScience",
      name: "Data Science",
      link: "/datascience",
      badge: "NEW",
    },
  ],
};

export default Tutorial_data;
